/* Lets remove this one when all templates are strict and import from the index file */
import { Optgroup } from "./";

export default Optgroup;
